const TESTCASE_TESTDATA_EDITOR = {
  theme: "idea",
  mode: "application/ld+json",
  lineNumbers: true,
  lineWrapping: true,
  foldGutter: true,
  autoCloseBrackets: true,
  matchBrackets: true,
  lint: true,
  gutters: ["CodeMirror-linenumbers", "CodeMirror-lint-markers"],
  autoRefresh: true,
};

export { TESTCASE_TESTDATA_EDITOR as tctd_editorConfig };
